export default "__VITE_ASSET__Cqvjum27__"